export enum AuthQrantTypeEnum {
  LDAP = 'LDAP',
  STANDARD = 'USERPASS'
}
